import React from "react"
import Modal from "aldoo-ra/Modal"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"

const StoreCancellationDialog = ({
  isOpen,
  onClose,
  storeInfo,
}) => {
  
  const handleCancelOnStore = () => {
    window.open(storeInfo.cancel_url, '_blank')
    onClose()
  }

  return (
    <Modal
      title="Cancel Subscription"
      isOpen={isOpen}
      onClose={onClose}
      variant="centered"
      className="max-w-[500px]"
    >
      <div className="space-y-6">
        {storeInfo?.store_logo && (
          <div className="flex justify-center">
            <img
              src={storeInfo.store_logo}
              alt="Store Logo"
              className="h-20 w-auto"
            />
          </div>
        )}

        <Typography
          variant="info_18"
          className="text-text text-center my-0"
        >
          {storeInfo?.description}
        </Typography>

        <div className="flex justify-center">
          <Button 
            variant="primary_s" 
            onClick={handleCancelOnStore}
            className="min-w-[110px]"
          >
            Go to Store
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default StoreCancellationDialog